import { Header } from '@components/Header';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const HeaderSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Header"
      description="Main application header with logo, navigation tabs, and logout button. Logo automatically switches color based on theme."
      figmaNodeId="14-102"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Default Header (Auto Logo)</h3>
      <div className={styles.headerDemoBox}>
        <Header showLogout onLogout={() => alert('Logout clicked!')} />
      </div>
      <p className={styles.hint}>
        Logo automatically switches between black/white based on theme. Toggle theme to see it change.
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Header with Tabs</h3>
      <div className={styles.headerDemoBox}>
        <Header
          showLogout
          showTabs
          tabs={[
            { label: 'Overview', active: false, onClick: () => {} },
            { label: 'Generate Leads', active: true, onClick: () => {} },
            { label: 'Manage Leads', active: false, onClick: () => {} },
          ]}
          onLogout={() => alert('Logout clicked!')}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Header without Logout</h3>
      <div className={styles.headerDemoBox}>
        <Header showLogout={false} />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Forced White Logo (for custom dark containers)</h3>
      <div className={styles.headerDemoBoxDark}>
        <Header logoVariant="white" showLogout onLogout={() => alert('Logout clicked!')} />
      </div>
      <p className={styles.hint}>
        Use <code>{`logoVariant="white"`}</code> to force white logo regardless of theme.
      </p>
    </div>
  </section>
);
